/*
 * @Author: wolfsheller
 * @Description: 小票配置管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: James Wong
 * @Last Modified time: 2019-03-14 14:36:02
 */
const newreceipt = {
  state: {
    saleSlipType: '',
    receiptModelSetFlag: '',
    setChannel: [],
    setAllChannel: [],
    channelSetModelFlag: ''
  },
  mutations: {
    SET_RECEIPTMODELSET_FLAG(state, val) {
      state.receiptModelSetFlag = val
    },
    SET_SETCHANNEL_ARR(state, {selectData = [], selectAllData = []}) {
      state.setChannel = selectData
      state.setAllChannel = selectAllData
    },
    SET_CHANNELSETMODEL_FLAG(state, val) {
      state.channelSetModelFlag = val
    },
    SET_SALESLIPTYPE(state, val) {
      state.saleSlipType = val
    }
  }
}

export default newreceipt


// WEBPACK FOOTER //
// ./src/store/modules/newreceipt.js